import * as MaterialUiIcons from "@mui/icons-material";
import * as React from "react";
import { FunctionComponent } from "react";

const SettingsIcon: FunctionComponent = () => <MaterialUiIcons.Settings />;

export default SettingsIcon;
